module.exports = "query GetPages {\n  pages(first: 500) {\n    slug\n  }\n}\n"